import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { SparklesIcon } from "@/shared/icons";
import { AppLink } from "@/shared/Components";
import { type AnniversaryEvent, EventTypes } from "@/services/api";
import { useCalendarEventItem } from "@/entities/calendar-event/model";
import type { Dayjs } from "dayjs";
import { getAnniversaryText, getBirthdayText } from "../../../utils";
import styles from "../styles.module.scss";
import { CalendarEventNoteContent } from "../calendar-event-note-content";

interface Props {
  type: EventTypes;
  id: string;
  currentDate: Dayjs;
  anniversaryRecord?: AnniversaryEvent;
}

export const CalendarEventItem: React.FC<Props> = ({
  type,
  id,
  currentDate,
  anniversaryRecord,
}) => {
  const { person, note, anniversary } = useCalendarEventItem(id, type, currentDate);
  const navigate = useNavigate();

  const getContent = () => {
    switch (type) {
      case EventTypes.BIRTHDAY: {
        return (
          <div className={styles["flex-container"]}>
            <SparklesIcon />
            <AppLink
              onClick={() => navigate(`/contacts/generalInfo/${person?.id}`)}
              className={styles["todo-link"]}
            >
              {getBirthdayText(person)}
            </AppLink>
          </div>
        );
      }
      case EventTypes.NOTE: {
        // TODO: Do normal way to make it readable
        return <CalendarEventNoteContent note={note?.note} person={note?.person} />;
      }
      case EventTypes.ANNIVERSARY: {
        return (
          <div
            className={styles["flex-container"]}
            onClick={() => {
              navigate(`/contacts/generalInfo/${anniversary?.id}`);
            }}
          >
            <SparklesIcon />
            <AppLink className={styles["todo-link"]}>
              {getAnniversaryText(anniversary, anniversaryRecord)}
            </AppLink>
          </div>
        );
      }
    }
  };

  return (
    <li>
      <div className={classNames(styles["task-item"])}>{getContent()}</div>
    </li>
  );
};
